import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { OperatorCard, LoadingBlock } from "@/components/site/Cards";

export default function Operators() {
  const [operators, setOperators] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [industry, setIndustry] = useState("");
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/industries").then((r) => setIndustries(r.data));
  }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/operators", { params: { industry: industry || undefined, q: q || undefined } })
      .then((r) => setOperators(r.data))
      .finally(() => setLoading(false));
  }, [industry, q]);

  return (
    <div data-testid="operators-page">
      <section className="border-b border-oc-hairline">
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16 md:py-24">
          <div className="eyebrow text-oc-coral mb-6">The People</div>
          <h1 className="hero-headline text-5xl md:text-7xl text-oc-ink">Operators</h1>
          <p className="mt-6 font-editorial text-xl text-oc-ink-soft max-w-2xl">
            The people behind the conversations. Founders, owners, managers, executives, and builders who have accepted responsibility for making organizations work.
          </p>
        </div>
      </section>

      <section className="border-b border-oc-hairline">
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row gap-4 items-start md:items-center">
          <div className="eyebrow text-oc-ink-muted">Filter</div>
          <select
            data-testid="operators-industry-filter"
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
            className="h-10 px-3 bg-white border border-oc-hairline font-ui text-sm cursor-pointer"
          >
            <option value="">All industries</option>
            {industries.map((i) => (
              <option key={i.slug} value={i.slug}>{i.name}</option>
            ))}
          </select>
          <input
            data-testid="operators-search"
            placeholder="Search operators..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="h-10 px-3 bg-white border border-oc-hairline font-ui text-sm w-full md:w-64"
          />
        </div>
      </section>

      <section>
        <div className="max-w-editorial mx-auto px-6 md:px-10 py-16">
          {loading ? (
            <LoadingBlock />
          ) : operators.length === 0 ? (
            <div className="py-24 text-center font-editorial text-xl text-oc-ink-muted">No operators found.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {operators.map((op) => (
                <OperatorCard key={op.slug} operator={op} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
